import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import 'babel-polyfill';
import 'whatwg-fetch';

import App from './app/App';
import The350ClubClosed from './app/pages/info/The350ClubClosed';
import store from './app/services/store';
import * as api from './app/services/api';
import * as http from './app/services/apis/http';
import { CONSTANTS, JARGON } from './app/modules/constants';

api.setStore(store);
http.setStore(store);

const the350clubClosed = !CONSTANTS.THE350CLUB_ENABLED &&
  new URLSearchParams(window.location.search).get("source") === JARGON.THE350CLUB

ReactDOM.render(
  the350clubClosed
    ? <The350ClubClosed />
    : <Provider store={store}>
      <App />
    </Provider>,

  document.getElementById('content')
);
